export var LayoutPosition;

(function (LayoutPosition) {
  LayoutPosition["horizontall"] = "1";
  LayoutPosition["vertical"] = "2";
})(LayoutPosition || (LayoutPosition = {}));

export var EWidgetType;

(function (EWidgetType) {
  EWidgetType[EWidgetType["payment"] = 1] = "payment";
  EWidgetType[EWidgetType["forms"] = 2] = "forms";
  EWidgetType[EWidgetType["appointments"] = 3] = "appointments";
  EWidgetType[EWidgetType["b2m"] = 4] = "b2m";
  EWidgetType[EWidgetType["hazardReports"] = 5] = "hazardReports";
  EWidgetType[EWidgetType["waterData"] = 6] = "waterData";
  EWidgetType[EWidgetType["updates"] = 7] = "updates";
  EWidgetType[EWidgetType["openeds"] = 8] = "openeds";
  EWidgetType[EWidgetType["documents"] = 11] = "documents";
  EWidgetType[EWidgetType["container"] = 1000] = "container";
})(EWidgetType || (EWidgetType = {}));

export var ELayoutType;

(function (ELayoutType) {
  ELayoutType[ELayoutType["webNotConnected"] = 1] = "webNotConnected";
  ELayoutType[ELayoutType["webConnected"] = 2] = "webConnected";
  ELayoutType[ELayoutType["appNotConnetcted"] = 3] = "appNotConnetcted";
  ELayoutType[ELayoutType["appConnected"] = 4] = "appConnected";
})(ELayoutType || (ELayoutType = {}));

export var EItemsInWidgetType;

(function (EItemsInWidgetType) {
  EItemsInWidgetType[EItemsInWidgetType["form"] = 1] = "form";
  EItemsInWidgetType[EItemsInWidgetType["externalLink"] = 2] = "externalLink";
  EItemsInWidgetType[EItemsInWidgetType["module"] = 3] = "module";
})(EItemsInWidgetType || (EItemsInWidgetType = {}));